import { createAsyncThunk } from "@reduxjs/toolkit";
import { API, axiosInstance } from "lib";

// export const getUserlist = createAsyncThunk(
//   "Get User",
//   async (data = {}, { rejectWithValue }) => {
//     try {
//       const response = await axiosInstance.post(API.GET_USER_LIST, data);
//       return response.data;
//     } catch (err) {
//       return rejectWithValue(err.response.data);
//     }
//   }
// );

export const getUserlist = createAsyncThunk(
  "Get User",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(API.GET_USER_LIST + `?` +`userId=${data?.userId}&page=${data?.page}&limit=${data?.limit}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch environment data"
      );
    }
  }
);




export const getUserDetails = createAsyncThunk(
  "Get User Details",
  async (data = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(API.GET_USER_DETAIL + `?` +`userId=${data?.userId}&userIdToRetrive=${data?.userIdToRetrive}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
